<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2022-03-25 15:34:26
 * @LastEditors: hexy
 * @LastEditTime: 2023-11-27 16:07:25
 * @Description: 
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\components\addUserForm.vue
-->

<template>
    <el-dialog
    title="添加用户"
    :visible.sync="visible"
    width="400px"
    :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="姓名：" required>
                <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" required>
                <el-input v-model="form.phoneNum" type="Number" oninput="if(value.length > 11)value = value.slice(0, 11)" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="登录账号：" required>
                <el-input v-model="form.loginAccount" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="角色：">
                <el-select v-model="form.roleIdList" placeholder="请选择用户角色" multiple>
                    <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户类型：">
                {{type === 1 ? '供应商': '客户'}}
            </el-form-item>
            <el-form-item label="所属组织：">
                {{form.company}}
            </el-form-item>
        </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitAction">确 定</el-button>
    </span>
    </el-dialog>
</template>

<script>
import { saveUser, coverUser} from '@/api/basedata/user'
export default {
    props: ['form', 'roleList', 'type', 'visible'],
    methods: {
        submitAction() {
            let params = {...this.form, loginType: 3, createChindAccount: 0, userTypeId: 'bfea309fc7ac46a4b5c90746e0083b00', 
                // roleIdList: JSON.stringify(this.form.roleIdList)
            }
            if (this.type === 1) {
                params.userTypeId = '0ae85d17f3d0471eb945de7c1eaf440f'
            }
            saveUser(params).then(res => {
                if (res.code === 1001) {
                    this.$message.success('添加成功')
                    this.$emit('saveDone')
                }else if(res.code === 1032){
                    this.$confirm('账号/电话已被使用，是否删除占用用户创建新用户?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      cancelButtonClass: 'bottom_all_two',
                      confirmButtonClass: 'bottom_all',
                      type: 'warning'
                    }).then(() => {
                        coverUser(params).then(res => {
                        if(res.code == 1001) {
                          this.$message.success('成功!')
                          this.$emit('saveDone')
                        }
                      })
                    })
                }
            })
        },
        close() {
            this.$emit('close')
        },
        handleClose() {
            this.$emit('close')
        }
    }
}
</script>